module.exports = __webpack_public_path__ + "img/etherscan.387d6e75.svg";